<template>
  <div class="bank-list-outer">
    <div class="bank-list-wrapper">
      <div
        v-for="bank in list"
        :key="bank.acquirerCode"
        @click="bank.active ? selectBank(bank.acquirerCode) : null"
      >
        <div
          class="bank-card"
          @mouseover="!bank.active ? (showBankDown = true) : null"
          @mouseleave="!bank.active ? (showBankDown = false) : null"
        >
          <div class="bank-block-outer" :class="!bank.active ? 'disabled' : ''">
            <div
              class="bank-block"
              :style="{ backgroundColor: bank.background }"
            ></div>
            <div class="bank-text">
              {{ bank.label ? bank.label : bank.acquirerName }}
            </div>
          </div>
          <div v-if="!bank.active && showBankDown" class="tooltip-text-outer">
            <div class="tooltip-text">
              <img
                src="../assets/images/notification_failed.svg"
                alt="Bank down image"
              />
              <span
                >This bank is temporarily unavailable. Please see main page for
                details</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankList',
  props: { list: Array, showBankDown: Boolean },

  methods: {
    async selectBank(acquirerCode) {
      this.$emit('select-bank', acquirerCode)
    },
  },
}
</script>

<style scoped lang="scss">
.bank-list-outer {
  display: flex;
  justify-content: center;
}

.bank-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin-bottom: 60px;
  width: 456px;

  @media screen and (max-width: $mobile-resolution) {
    margin-bottom: 23.5px;
    width: 288px;
  }
}

.bank-block-outer {
  align-items: center;
  display: flex;
  height: 100%;

  &:hover {
    box-shadow: 0px 5px 15px rgba(41, 156, 208, 0.3);
  }

  &.disabled {
    cursor: not-allowed;
    -webkit-filter: brightness(90%); /* Safari 6.0 - 9.0 */
    filter: brightness(90%);
    opacity: 0.7;

    &:hover {
      box-shadow: 0px 5px 15px rgba(134, 134, 134, 0.3);
    }
  }
}

.bank-card {
  width: 120px;
  height: 120px;
  margin: 8px 16px 8px 16px;
  background: #ffffff;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  cursor: pointer;

  @media screen and (max-width: $mobile-resolution) {
    height: 72px;
    margin: 8px 12px 8px 12px;
  }
}

.bank-text {
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  padding: 12px 15px 12px 9px;
  width: 100%;

  @media screen and (max-width: $mobile-resolution) {
    font-size: 14px;
    line-height: 17px;
  }
}

.bank-block {
  float: left;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  min-width: 6px;
  height: 80px;
  background-color: #3299cf;

  @media screen and (max-width: $mobile-resolution) {
    height: 48px;
  }
}

.bank-title {
  font-size: 12px;
  text-align: center;
}

.tooltip-text-outer {
  position: relative;
  width: 0;
  height: 0;
}

.tooltip-text {
  background-color: #fee8e5;
  color: #f34e4e;
  border: 1px solid rgba(250, 138, 125, 0.15);
  padding: 20px 10px 20px 10px;
  border-radius: 12px;
  width: 250px;
  margin-left: -60px;
  top: -220px;
  position: absolute;
  z-index: 1;
  vertical-align: middle;

  @media screen and (max-width: $mobile-resolution) {
    top: -170px;
  }

  img {
    float: left;
    padding: 12px 10px 12px 10px;
  }
}
</style>
